(function () {
  'use strict';

  /*
   * LE SOUVENIR SIMPLE — Catalogue de l'Atelier
   * ------------------------------------------------------------
   * Ce fichier est volontairement séparé du moteur du configurateur.
   * Quand le fournisseur définitif et le stock réel seront arrêtés,
   * c'est principalement CE fichier qui devra évoluer.
   *
   * Fournisseur candidat préconfiguré : Jootjes Haakcadeautjes.
   * Les noms de couleurs ci-dessous reprennent des références visibles
   * dans son catalogue au 08/08/2026. Les valeurs HEX ne sont que des
   * approximations d'affichage et devront être recalées sur les photos
   * / échantillons réels avant publication définitive.
   */

  window.LSSVotreSouvenirCatalogue = {
    version: 5,

    supplier: {
      id: 'jootjes-candidate',
      name: 'Jootjes Haakcadeautjes',
      status: 'candidate',
      publicUrl: 'https://www.jootjeshaakcadeautjes.nl/fr/',
      note: 'Fournisseur candidat. Les références finales, lots, stocks et documents de conformité doivent être validés par Le Souvenir Simple avant utilisation en production.'
    },

    ui: {
      currency: 'EUR',
      stockMode: 'catalogue-static',
      showSupplierNameToCustomer: false,
      swatchDisclaimer: 'Les teintes à l’écran peuvent légèrement différer des éléments réels.'
    },

    letters: {
      type: 'silicone-square',
      material: 'silicone',
      widthMm: 12,
      heightMm: 12,
      axisMm: 12,
      axisConfirmed: true,
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      specialCharactersObserved: ['É', 'È', 'Ë', 'Ï'],
      specialCharacterAvailabilityMustBeChecked: true,
      note: 'Le fournisseur candidat propose des perles-lettres silicone carrées 12 x 12 mm A-Z. Certaines lettres accentuées existent sur des références spécifiques.'
    },

    palettes: {
      silicone: [
        { id: 'coco', name: 'Coco', hex: '#D8C5B3', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'galet', name: 'Galet', hex: '#B8B2A9', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'bois-de-rose', name: 'Bois de rose', hex: '#B88C82', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'rose-doux', name: 'Rose doux', hex: '#D9B8B7', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'lilas-poudre', name: 'Lilas poudré', hex: '#B9A6B5', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'pistache', name: 'Pistache', hex: '#B6BE9F', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'taupe', name: 'Taupe', hex: '#9A897B', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'nude-peche', name: 'Nude pêche', hex: '#DAB5A1', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'bleu-poudre-clair', name: 'Bleu poudré clair', hex: '#B9C8CD', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'menthe-clair', name: 'Menthe clair', hex: '#BFD2C3', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'dark-rose-champagne', name: 'Dark Rose Champagne', hex: '#B88F88', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'brun-faon', name: 'Brun faon', hex: '#A57D62', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'noir', name: 'Noir', hex: '#3D3937', supplierNameConfirmed: true, hexApproximate: true, active: true }
      ],

      wood: [
        { id: 'hetre-naturel', name: 'Hêtre naturel', hex: '#C9A77D', supplierNameConfirmed: true, hexApproximate: true, active: true },
        { id: 'erable-naturel', name: 'Érable naturel', hex: '#D4B993', supplierNameConfirmed: true, hexApproximate: true, active: true }
      ]
    },

    kinds: {
      round: {
        id: 'round',
        label: 'Perle ronde',
        shortLabel: 'Ronde',
        symbol: '○',
        active: true,
        materials: {
          silicone: {
            label: 'Silicone',
            palette: 'silicone',
            defaultSizeId: 'sil-round-12',
            sizes: [
              { id: 'sil-round-9', label: '9 mm', diameterMm: 9, axisMm: 9, axisSource: 'geometric-round', supplierObserved: true, active: true },
              { id: 'sil-round-12', label: '12 mm', diameterMm: 12, axisMm: 12, axisSource: 'geometric-round', supplierObserved: true, active: true },
              { id: 'sil-round-16', label: '16 mm', diameterMm: 16, axisMm: 16, axisSource: 'geometric-round', supplierObserved: true, active: true },
              { id: 'sil-round-20', label: '20 mm', diameterMm: 20, axisMm: 20, axisSource: 'geometric-round', supplierObserved: true, active: true }
            ]
          },

          wood: {
            label: 'Bois',
            palette: 'wood',
            defaultSizeId: 'wood-round-16',
            sizes: [
              { id: 'wood-round-10', label: '10 mm', diameterMm: 10, axisMm: 10, axisSource: 'provisional-user-report', supplierObserved: false, active: true },
              { id: 'wood-round-12', label: '12 mm', diameterMm: 12, axisMm: 12, axisSource: 'provisional-user-report', supplierObserved: false, active: true },
              { id: 'wood-round-14', label: '14 mm', diameterMm: 14, axisMm: 14, axisSource: 'provisional-user-report', supplierObserved: false, active: true },
              { id: 'wood-round-16', label: '16 mm', diameterMm: 16, axisMm: 16, axisSource: 'geometric-round', supplierObserved: true, active: true },
              { id: 'wood-round-20', label: '20 mm', diameterMm: 20, axisMm: 20, axisSource: 'geometric-round', supplierObserved: true, active: true }
            ]
          }
        }
      },

      flat: {
        id: 'flat',
        label: 'Perle plate',
        shortLabel: 'Plate',
        symbol: '▭',
        active: true,
        materials: {
          silicone: {
            label: 'Silicone',
            palette: 'silicone',
            defaultSizeId: 'sil-abacus-14',
            sizes: [
              {
                id: 'sil-oval-12',
                label: 'Ovale 12 mm',
                diameterMm: 12,
                axisMm: null,
                supplierObserved: true,
                active: true,
                technicalNote: 'L’épaisseur longitudinale doit être mesurée sur la référence réellement commandée.'
              },
              {
                id: 'sil-abacus-14',
                label: 'Abacus 14 mm',
                diameterMm: 14,
                axisMm: null,
                supplierObserved: true,
                active: true,
                technicalNote: 'Le fournisseur candidat confirme le format 14 mm, mais pas l’épaisseur sur l’axe du cordon.'
              }
            ]
          },

          wood: {
            label: 'Bois',
            palette: 'wood',
            defaultSizeId: 'wood-flat-12',
            sizes: [
              { id: 'wood-flat-10', label: 'Ø 10 mm · env. 5–6 mm', diameterMm: 10, axisMm: 5.5, axisSource: 'provisional-user-report', supplierObserved: false, active: true },
              { id: 'wood-flat-12', label: 'Ø 12 mm · env. 5–6 mm', diameterMm: 12, axisMm: 5.5, axisSource: 'provisional-user-report', supplierObserved: false, active: true }
            ]
          }
        }
      },

      motif: {
        id: 'motif',
        label: 'Motif',
        shortLabel: 'Motif',
        symbol: '✦',
        active: true,
        materials: {
          silicone: {
            label: 'Silicone',
            palette: 'silicone',
            defaultMotifId: 'oiseau',
            sizes: [],
            motifs: [
              {
                id: 'oiseau',
                label: 'Oiseau',
                symbol: '◇',
                widthMm: 24,
                heightMm: 25,
                axisMm: null,
                supplierObserved: true,
                active: true,
                preferredColorIds: ['rose-doux']
              },
              {
                id: 'lune-brindille',
                label: 'Lune avec brindille',
                symbol: '☾',
                widthMm: null,
                heightMm: null,
                axisMm: null,
                supplierObserved: true,
                active: true,
                preferredColorIds: ['bleu-poudre-clair', 'menthe-clair', 'dark-rose-champagne', 'brun-faon']
              },
              {
                id: 'cheval',
                label: 'Cheval',
                symbol: '♘',
                widthMm: null,
                heightMm: null,
                axisMm: null,
                supplierObserved: true,
                active: true,
                preferredColorIds: ['galet', 'coco', 'hetre-naturel']
              },
              {
                id: 'cygne-3d',
                label: 'Cygne 3D',
                symbol: '♢',
                widthMm: null,
                heightMm: null,
                axisMm: null,
                supplierObserved: true,
                active: true,
                preferredColorIds: ['rose-doux', 'coco']
              }
            ]
          }
        }
      }
    },

    inspirationPresets: [
      {
        id: 'douceur-naturelle',
        title: 'Douceur naturelle',
        description: 'Des tons doux, un rythme léger et une présence de matière naturelle.',
        colorIds: ['coco', 'pistache', 'hetre-naturel'],
        preferredKinds: ['round', 'flat']
      },
      {
        id: 'tendre-contraste',
        title: 'Tendre contraste',
        description: 'Une base claire relevée par une teinte plus profonde, sans surcharger le prénom.',
        colorIds: ['rose-doux', 'coco', 'taupe'],
        preferredKinds: ['round', 'motif']
      },
      {
        id: 'petit-ciel',
        title: 'Petit ciel',
        description: 'Des nuances poudrées et un motif délicat pour une composition aérienne.',
        colorIds: ['bleu-poudre-clair', 'coco', 'lilas-poudre'],
        preferredKinds: ['flat', 'motif']
      }
    ],

    technical: {
      standardReference: 'NF EN 12586 / EN 12586:2025',
      maxOverallMm: 300,
      maxWithoutGarmentFastenerMm: 220,
      maxClosedLoopMm: 110,
      fixedAssemblyAllowanceMm: null,
      automaticFinalConformity: false,
      blockWhenKnownComponentsAloneExceedLimit: true,
      warningRatio: 0.72,
      highRatio: 0.88,
      note: 'Le configurateur est un outil d’aide à la conception. Il ne remplace pas les contrôles de fabrication, essais ni obligations applicables au produit fini.'
    },

    privacy: {
      secureStoryEnabled: false,
      secureStoryEndpoint: null,
      note: 'Le texte libre sensible n’est pas enregistré dans Shopify tant qu’un canal sécurisé dédié n’est pas configuré.'
    }
  };
})();
